import businessClient from 'src/services/clients/business'

import { IMeta, ILocation, ISetLocation } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '', endpoint: '' } }
const ILocationsResponse = { meta: IMeta, data: { list: [ILocation] } }
const ISetLocationResponse = { meta: IMeta, data: { update: [ISetLocation] } }

export const integrationDeliveroo = {
  /**
   * @return {Promise<IResponse>}
   */
  pairSystem(data, signal) {
    return businessClient().post('apppair/deliveroo/pair/business', { data }, { signal })
  },

  /**
   * @return {Promise<ILocationsResponse>}
   */
  locationsList(signal) {
    return businessClient().post('apppair/deliveroo/location/portal/list', {}, { signal })
  },

  /**
   * @param {{ store_id: number, deliveroo_store_id: string  }} data
   * @return {Promise<ISetLocationResponse>}
   */
  pairStore(data, signal) {
    return businessClient().post('apppair/deliveroo/pair/store', { data }, { signal })
  },

  /**
   * @return {Promise<ISquareResourceResponse>}
   */
  disconnect(signal) {
    return businessClient().post('apppair/deliveroo/disconnect', {}, { signal })
  },

  /**
   * @param {{store_id: number, auto_accept_minute: number }} data
   * @return {Promise<IResponse>}
   */
  autoAccept(data, signal) {
    return businessClient().post('apppair/deliveroo/auto-accept', { data }, { signal })
  },
}
